import { useState } from "react";
import styles from "./../styles.module.css";
import Modal from "react-responsive-modal";
import Table from "../../../../components/TableConstructor";
import RowEquipamento from "../../../../components/TableConstructor/Row/RowEquipamento";
import { Equipamento } from "../../../../model/PlanoDeTrabalho/AquisicaoDeEquipamentos";
import ModalItem from "../../../../components/ModalForms/ModalItem";
import { MetaFisica } from "../../../../model/PlanoDeTrabalho/CronogramaExecucao";

type Props = {
  passarPagina: Function;
  voltarPagina: Function;
  itens: Equipamento[];
  setItens: React.Dispatch<React.SetStateAction<Equipamento[]>>;
  listaMetas: MetaFisica[];
};

function RelacaoEquipamentos({
  passarPagina,
  voltarPagina,
  itens,
  setItens,
  listaMetas,
}: Props) {
  const [showAddEquipamento, setAddEquipamento] = useState(false);
  const [showEditEquipamento, setEditEquipamento] = useState(-1);

  return (
    <div>
      <h2 className={styles.titulo}>
        6.1. Relação dos Equipamentos e Materiais <strong>Permanentes</strong>:
      </h2>
      <div>
        <Table
          listTitle={[
            "Item",
            "Nome e Especificação do Equipamento",
            "Quantidade",
            "Valor Unitário",
            "Valor Total",
            "",
          ]}
          styleList={[1, 0, 1, 1, 1, 0]}
        >
          {itens.map((itemObj, index) => (
            <RowEquipamento itemObj={itemObj} metaIndex={index} key={index}>
              <>
                <button
                  className={styles.btn}
                  onClick={() => setEditEquipamento(index)}
                >
                  Editar
                </button>
                <Modal
                  open={showEditEquipamento === index}
                  onClose={() => setEditEquipamento(-1)}
                  center
                  classNames={{
                    modal: "customModal",
                  }}
                >
                  <ModalItem
                    closeModal={() => setEditEquipamento(-1)}
                    list={itens}
                    setList={setItens}
                    index={index}
                    listaMetas={listaMetas}
                    refMeta={itemObj}
                  />
                </Modal>
              </>
            </RowEquipamento>
          ))}
        </Table>
        <div className={styles.addDiv}>
          <button
            className={styles.addBtn}
            onClick={(e) => {
              e.preventDefault();
              setAddEquipamento(true);
            }}
          >
            + Adicionar Meta
          </button>
        </div>
        <Modal
          open={showAddEquipamento}
          onClose={() => setAddEquipamento(false)}
          center
          classNames={{
            modal: "customModal",
          }}
        >
          <ModalItem
            closeModal={() => setAddEquipamento(false)}
            list={itens}
            setList={setItens}
            listaMetas={listaMetas}
          />
        </Modal>
      </div>
      <hr className={styles.separador} />
      <div className="flex justify-between">
        <button
          className={styles.passarTelaBtn}
          onClick={() => {
            voltarPagina();
          }}
        >
          ❮❮ Anterior
        </button>
        <button
          className={styles.passarTelaBtn}
          onClick={() => {
            passarPagina();
          }}
        >
          Proximo ❯❯
        </button>
      </div>
    </div>
  );
}

export default RelacaoEquipamentos;
